// @flow

import { getUiSetting, getUiSettingOrDefault, type State as UiState } from '../uiStore';
import { getLoadingStateKey, getSubmitSuccessKey, getSubmitFailedKey } from './actions';

type GlobalState = {
  uiSettings: UiState,
};

export const isFormLoading = (state: GlobalState, formName: string) => (
  getUiSetting(state, getLoadingStateKey(formName))
);

export const isSubmitted = (state: GlobalState, formName: string): boolean => (
  Boolean(getUiSettingOrDefault(state, getSubmitSuccessKey(formName), false))
);

export const hasError = (state: GlobalState, formName: string): boolean => (
  Boolean(getUiSettingOrDefault(state, getSubmitFailedKey(formName), false))
);
